import React, { Suspense, lazy } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { createBrowserHistory } from "history"
import { CircularProgress } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { index } from './store/actions/app.action'

const Auth = lazy(() => import('./view/auth'))
const VerifyDevice = lazy(() => import('./view/auth/verify-device'))
const TwoFaMethod = lazy(() => import('./view/auth/2fa-method'))

const Users = lazy(() => import('./view/mobile/users'))
const Pixel = lazy(() => import('./view/mobile/pixel'))
const Utms = lazy(() => import('./view/mobile/utms'))
const Google = lazy(() => import('./view/mobile/google'))
const Webhooks = lazy(() => import('./view/mobile/webhooks'))
const Campaigns = lazy(() => import('./view/mobile/campaigns'))
const Account = lazy(() => import('./view/mobile/account'))
const PaymentAvailable = lazy(() => import('./view/mobile/account/available'))

const Closed = lazy(() => import('./view/mobile/campaigns/closed'))
const Trash = lazy(() => import('./view/mobile/campaigns/trash'))
const Afiliados = lazy(() => import('./view/mobile/afiliados'))
const Gestores = lazy(() => import('./view/mobile/gestor'))
const Settings = lazy(() => import('./view/mobile/config/settings'))
const Password = lazy(() => import('./view/mobile/config/password'))
const Capitalizer = lazy(() => import('./view/mobile/capitalizer'))
const Theme = lazy(() => import('./view/mobile/theme'))
const Secure = lazy(() => import('./view/mobile/secure'))
const Notifications = lazy(() => import('./view/mobile/notifications'))

const RoutesMobile = () => {
    const history = createBrowserHistory()
    const [loading, setLoading] = React.useState(true)
    const dispatch = useDispatch() 

    React.useEffect(() => {
        if(history.location.pathname !== '/login') {
            dispatch(index()).then(res => res && setLoading(false))
        }else {
            setLoading(false)
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    return (
        <>
        {(history.location.pathname !== '/login' && loading ) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
        <Router>
            <Suspense fallback={<div className="d-flex justify-content-center align-items-center min-vh-100"> <CircularProgress/> </div>}>
                <Switch>
                    <Route exact path="/pixel" component={Pixel} />
                    <Route exact path="/utms" component={Utms} />
                    <Route exact path="/notifications" component={Notifications} />
                    <Route exact path="/afiliados" component={Afiliados} />
                    <Route exact path="/gestores" component={Gestores} />
                    <Route exact path="/google-tag-manager" component={Google} />
                    <Route exact path="/gateway-payment" component={Account} />
                    <Route exact path="/gateway-payment/available" component={PaymentAvailable} />
                    
                    <Route exact path="/password" component={Password} />
                    <Route exact path="/webhooks" component={Webhooks} />
                    <Route exact path="/capitalizer" component={Capitalizer} />
                    <Route exact path="/theme" component={Theme} />
                    <Route exact path="/secure" component={Secure} />
                    <Route exact path="/settings" component={Settings} />
                    <Route exact path="/supporters" component={Users} />
                    <Route exact path="/campaigns" component={Campaigns} />
                    <Route exact path="/campaigns/closed" component={Closed} />
                    <Route exact path="/campaigns/trash" component={Trash} />
                    <Route exact path="/login" component={Auth} />
                    <Route exact path="/2fa/verify/:method" component={VerifyDevice} />
                    <Route exact path="/2fa/method" component={TwoFaMethod} />
                    <Route exact path="/" component={Campaigns} />
                </Switch>
            </Suspense>
        </Router>
        }
        </>
    )
}

export default RoutesMobile;